import React from 'react';
import './KpiTile.css';

export interface KpiDelta {
  /** Formatted delta text, e.g. "+12.4%" */
  text: string;
  direction: 'up' | 'down' | 'flat';
  /** Whether this direction is good news (colors the delta). */
  good?: boolean;
}

interface KpiTileProps {
  label: string;
  /** Formatted headline value; pass "—" for no-data. */
  value: string;
  delta?: KpiDelta;
  /** Small print under the value (e.g. "vs prior 30 days"). */
  note?: string;
}

const ARROWS: Record<KpiDelta['direction'], string> = {
  up: '▲',
  down: '▼',
  flat: '—',
};

const KpiTile: React.FC<KpiTileProps> = ({ label, value, delta, note }) => (
  <div className="kpi-tile">
    <div className="kpi-tile-label">{label}</div>
    <div className="kpi-tile-value">{value}</div>
    {(delta || note) && (
      <div className="kpi-tile-footer">
        {delta && (
          <span
            className={`kpi-tile-delta ${
              delta.direction === 'flat' ? '' : delta.good ? 'kpi-tile-delta--good' : 'kpi-tile-delta--bad'
            }`}
          >
            {ARROWS[delta.direction]} {delta.text}
          </span>
        )}
        {note && <span className="kpi-tile-note">{note}</span>}
      </div>
    )}
  </div>
);

export default KpiTile;
